import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "button"]

  connect() {
    this.#toggle()
  }

  toggle() {
    this.#toggle()
  }

  #toggle() {
    this.buttonTarget.disabled = !(this.startDateTarget.value && this.endDateTarget.value)
  }
}
